import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getAnalytics, isSupported } from "firebase/analytics";

const getAuthDomain = () => {
  const hostname = window.location.hostname;
  // Use the default firebaseapp.com domain for local development and Codespaces
  if (hostname === 'localhost' || hostname.endsWith('.github.dev')) {
    return 'chicagojets2014-website.firebaseapp.com';
  }
  // Use the custom domain for production
  return hostname;
};

// Your web app's Firebase configuration
export const firebaseConfig = {
  apiKey: "AIzaSyB1TSepSjxSgamSBAf_N4bnkBQyGjCW4cQ",
  authDomain: getAuthDomain(),
  projectId: "chicagojets2014-website",
  storageBucket: "chicagojets2014-website.appspot.com",
  messagingSenderId: "350650275935",
  appId: "1:350650275935:web:ec691b884f202d609363ea",
  measurementId: "G-Q5F6FVR194"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);

// Initialize analytics safely
let analyticsInstance = null;
if (typeof window !== 'undefined' && process.env.NODE_ENV !== 'test') {
  isSupported().then(supported => {
    if (supported) {
      analyticsInstance = getAnalytics(app);
    }
  }).catch(() => {});
}

export const analytics = analyticsInstance;
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();

// Add scope to request profile picture from Google
provider.addScope('profile');